import { StyleSheet, Platform } from 'react-native'
// import Color from 'color'
import * as colors from '../../config/colors'
import * as v from '../../config/variables'

const styles = StyleSheet.create({
  container: {},
  // HGText
  text: {
    fontFamily: v.FONT_FAMILY_BASE,
    fontSize: v.FONT_SIZE_BASE,
    color: colors.black,
  },
  bold: {
    fontFamily: v.FONT_FAMILY_BOLD
  },
  // HGLink
  link: {
    fontWeight: 'bold',
    fontFamily: v.FONT_FAMILY_BOLD,
  },
  // HGHeading
  textHeading: {
    fontSize: 30,
    // marginHorizontal: v.SPACE_SM,
    marginTop: v.SPACE_MD,
    marginBottom: v.SPACE_SM * 2,
  },
  viewFullContainer: {
    // paddingTop: 19,
  },
  // HGButton
  button: {
    backgroundColor: colors.blue,
    height: 55,
    // minHeight: 50,
    minWidth: 50,
    maxWidth: 700,
    borderRadius: v.BORDER_RADIUS_SMALL,
    overflow: 'hidden', // border radius
  },
  buttonDisabled: {
    opacity: 0.5,
    // backgroundColor: Color(colors.white).alpha(0.5)
  },
  buttonLarge: {
    height: 70,
  },
  buttonSmall: {
    height: 45
  },
  buttonInner: {
    flex: 1,
    width: '100%',
    // padding: v.SPACE_SM*1.5,
    paddingHorizontal: 15,
    paddingVertical: 5,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonTypeInverted: {
    backgroundColor: colors.grayDark,
  },
  textButton: {
    flex: 1,
    textAlign: 'center',
    color: colors.white,
    fontFamily: v.FONT_FAMILY_BOLD,
  },
  textButtonInverted: {
    color: colors.white,
    // fontFamily: Platform.OS === 'android' ? 'Bariol_Bold' : 'Bariol',
    // fontWeight: Platform.OS === 'android' ? 'normal' : 'bold',
  },
  // HGModalFull
  modalFullContainer: {},
  // HGFlatList
  listStyle: {
    // paddingHorizontal: v.SPACE_SM,
    // flex: 1,
  },
  listItemInner: {
    // paddingVertical: v.SPACE_SM,
    // paddingHorizontal: v.SPACE_MD
    height: 80,
    backgroundColor: colors.white,
    paddingHorizontal: v.SPACE_MD,
    paddingVertical: v.SPACE_XS, // v.SPACE_SM,
    borderRadius: v.BORDER_RADIUS_SMALL,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  listItemDisabled: {
    opacity: 0.5,
  },
  listItemTitle: {
    fontWeight: Platform.OS === 'android' ? '400' : '500',
    fontFamily: v.FONT_FAMILY_BOLD,
    flexShrink: 1,
  },
  listItemDescription: {
    fontSize: v.FONT_SIZE_SMALL,
    color: colors.grayDark,
    // marginTop: v.SPACE_XS / 2,
  },
  listItemTextContainer: {
    // flexGrow: 0,
    flexShrink: 1,
    // flexWrap: 'wrap',
  },
  listItemIconContainer: {
    flexShrink: 0,
    // alignSelf: 'flex-end'
  },
  listItemIcon: {
    right: -10,
    color: colors.blue,
  },
  listItemIconCustom: {
    right: 0,
  },
  // HGGroup
  groupContainer: {
    // marginTop: v.SPACE_SM
  },
  groupContainerBox: {
    borderRadius: v.BORDER_RADIUS_SMALL,
    padding: v.SPACE_MD,
    paddingHorizontal: v.SPACE_SM,
    // marginVertical: v.SPACE_SM,
    // marginTop: v.SPACE_XS,
    marginBottom: v.SPACE_SM,
    backgroundColor: colors.white,
    overflow: 'hidden',
  },
  boxTransparent: {
    borderRadius: 0,
    backgroundColor: 'transparent',
    paddingHorizontal: 0,
    paddingVertical: 0,
    marginTop: v.SPACE_XS, // v.SPACE_SM
  },
  boxNoPadding: {
    padding: 0,
  },
  groupTitle: {
    color: colors.blue, // colors.gray,
    fontSize: v.FONT_SIZE_MEDIUM,
    // fontWeight: 'bold',
    // fontFamily: Platform.OS === 'android' ? 'Bariol_Bold' : 'Bariol',
    // fontWeight: Platform.OS === 'android' ? 'normal' : 'bold',
    marginTop: v.SPACE_MD,
    // marginHorizontal: v.SPACE_SM,
  },
})

export default styles
